import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { useEffect } from 'react';
import TopMenuStore from '@src/business-components/top-menu/store';
import Video from '@src/components/video';
import { getBackgroundMusic } from '@src/components/audio';
import aos from '@src/utils/aos';
import { jumpPage } from '@src/utils/common-util';
import Toast from '@src/business-components/common-message';
import { mechaData } from './mechaUnit';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();
const lang = getLanguageByPath();
import { getParameterByName } from '@src/utils/common-util.js';

class MechaUnitStore extends BaseStore {
  // 导航栏
  topMenuStore = new TopMenuStore({});
  // cv数据
  @observable cvList;
  // 页面数据
  @observable mechaData;
  // 当前cv音频
  @observable currentCvAudio;
  // 页面机甲/驾驶员
  @observable currentIndex = 0;
  // 语音当前播放的角标
  @observable cvIndex = null;
  // 当前音频是否播放
  @observable currentAudioState;
  // 语音tab角标
  @observable cvTabIndex = 0;
  @observable videoLink = '';
  // 语音TAB
  @observable cvTab;
  // 机甲id
  @observable id;
  // 机甲信息
  @observable mechaInfo = null;

  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }

  // 切换语音tab
  switchCvTab(i, lang) {
    this.cvTabIndex = i;
    console.log(i, lang);

    if (lang === 'ch') {
      console.log(this.mechaData?.zhCvList);

      return (this.cvList = this.mechaData?.zhCvList);
    } else if (lang === 'en') {
      return (this.cvList = this.mechaData?.enCvList);
    } else {
      return (this.cvList = this.mechaData?.jaCvList);
    }
  }
  goBack() {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit-list.html';
      jumpPage(url);
    } else {
      this.redirect('/mecha-unit-list');
    }
  }
  openVideo() {
    const videoUrl = this.mechaInfo?.videoUrl;
    if (!videoUrl) {
      return Toast.info(`${pageLocalesData.global.comming_soon}`);
    }

    Video.append({ src: videoUrl });
  }

  // 驾驶员/机甲
  switchInfo(i) {
    this.currentIndex = i;
  }
  onClickPlayRoleAudio(item, index) {
    // 1. 遍历 cvList 找到当前正在播放的项，关闭它
    this.cvIndex = index;
    this.cvList.forEach((cv, i) => {
      if (i !== index && cv.isPlay) {
        // 如果是其他项正在播放，则暂停它
        cv.isPlay = false;
      }
    });

    // 2. 切换当前点击项的播放状态
    this.cvList[index].isPlay = !this.cvList[index].isPlay;
    //
    if (this.cvList[index].isPlay) {
      // 播放音频
      if (!this.cvList[index].cvAudio_url) {
        return Toast.info(`${pageLocalesData.global.comming_soon}`);
      }

      this.currentCvAudio = this.cvList[index].cvAudio_url;
      this.bgmAudio.audio.src = this.currentCvAudio;
      this.bgmAudio && this.bgmAudio.play();
      this.currentAudioState = true;
    } else {
      this.currentAudioState = false;
      this.bgmAudio.stop();
    }
  }

  onResetAudioState = () => {
    // console.log('音频播放结束');
    // console.log(this.cvIndex);
    if (this.cvIndex !== null) {
      this.cvList[this.cvIndex].isPlay = false;
      this.currentAudioState = false;
    }
  };
  use() {
    super.use();
    this.id = getParameterByName('id');

    useEffect(
      () => {
        // 获取语音数据
        const data = mechaData
        this.cvList = data?.enCvList;
        let baihongData = pageLocalesData.mecha_unit.baihong
        this.cvTab = [
          {
            lang: pageLocalesData.mecha_unit.Voiced_by_text2,
            langType: 'en',
            name: baihongData.Voiced_name1
          },
          {
            lang: pageLocalesData.mecha_unit.Voiced_by_text3,
            langType: 'ja',
            name: baihongData.Voiced_name2
          },
          {
            lang: pageLocalesData.mecha_unit.Voiced_by_text1,
            langType: 'ch',
            name: baihongData.Voiced_name3
          }
        ];
        if (this.Lang() === 'ja') {
          this.cvList = data?.jaCvList;
          this.cvTab = [
            {
              lang: pageLocalesData.mecha_unit.Voiced_by_text3,
              langType: 'ja',
              name: baihongData.Voiced_name2
            },
            {
              lang: pageLocalesData.mecha_unit.Voiced_by_text2,
              langType: 'en',
              name: baihongData.Voiced_name1
            },
            {
              lang: pageLocalesData.mecha_unit.Voiced_by_text1,
              langType: 'ch',
              name: baihongData.Voiced_name3
            }
          ];
        }
        this.mechaData = data;
      },
      [this.id]
    );
    useMount(async () => {
      if (this.mechaData) {
        aos.reInit();
        this.videoLink = this.mechaData.video_link;

        if (!this.bgmAudio) {
          this.bgmAudio = getBackgroundMusic({
            src: this.currentCvAudio,
            loop: false,
            endedCb: this.onResetAudioState
          });
        }
      }

    });
    useEffect(
      () => {
        if (this.cvList) {
          this.bgmAudio && this.bgmAudio.stop();
          this.onResetAudioState();
        }
      },
      [this.currentIndex, this.cvTabIndex]
    );
  }
}

export default MechaUnitStore;
